import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod/v4";
import { Companies } from "../../companies/Companies";

const searchSchema = z.object({
  search: z.string().optional().default(""),
});

export const Route = createFileRoute("/firmen/")({
  validateSearch: zodValidator(searchSchema),
  component: CompaniesRoute,
});

function CompaniesRoute() {
  const navigate = useNavigate();
  const search = Route.useSearch({ select: ({ search }) => search });

  const setSearch = (newSearch: string) => {
    navigate({
      to: "/firmen",
      search: { search: newSearch },
    });
  };

  return <Companies search={search} setSearch={setSearch} />;
}
